import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { typography } from "./typography";
import { components } from "./components";
import {
  primary,
  secondary,
  complementary,
  darkGray,
  redAlert,
  black,
  white,
} from "./color-palettes";

interface CustomColor {
  main: string;
  [key: string]: string;
}

declare module "@mui/material/styles" {
  interface Palette {
    complementary: CustomColor;
    darkGray: CustomColor;
    redAlert: CustomColor;
    black: CustomColor;
    white: CustomColor;
  }
  interface PaletteOptions {
    complementary?: CustomColor;
    darkGray?: CustomColor;
    redAlert?: CustomColor;
    black?: CustomColor;
    white?: CustomColor;
  }
}

const themeOptions = {
  name: "Starbucks",
  palette: {
    mode: "light" as const,
    primary,
    secondary,
    complementary: {
      ...complementary,
      contrastText: "#FFF",
    },
    darkGray,
    redAlert,
    black,
    white,
    error: {
      main: redAlert[800],
    },
    success: {
      main: primary[800],
    },
  },
  typography,
  components,
};

let theme = createTheme(themeOptions);
theme = responsiveFontSizes(theme);

export default theme;
